import React, { useEffect, useMemo } from 'react';
import { MatchingNoteName } from '@marageti/z4-sdk/lib/standards';
import { ComboBoxOption } from '@marageti/z4-lib';
import { TravelerTags } from '@marageti/z4-sdk/lib/people';
import { ReferralType, TripRequest } from '@marageti/z4-sdk/lib/travel';
import { Navigate } from 'react-router-dom';
import MatchConfirmationView from './match-confirmation-view';
import { useMatchingStore } from '../../../store';
import { specialNotesOptions } from '../../../utils/trip-requests';

const getAutoGenSpecialNotes = (tripRequest: TripRequest, cooperative: boolean): MatchingNoteName[] => {
  const notes: MatchingNoteName[] = [];
  if (tripRequest.travelers[0]?.tags?.includes(TravelerTags.VIP)) notes.push(MatchingNoteName.VIPTV);
  if (tripRequest.repeatTraveler) notes.push(MatchingNoteName.RepeatTV);
  if (tripRequest.referralType !== ReferralType.None) notes.push(MatchingNoteName.PRL);
  if (tripRequest.budgetFlexibility > 0) notes.push(MatchingNoteName.FlexibleBudget);
  if (cooperative) notes.push(MatchingNoteName.Special2TCsFor1Trip);
  return notes;
};

const MatchConfirmationContainer = () => {
  const {
    additionalComments,
    cooperativeMatch,
    error,
    selectedMatches,
    setAdditionalComments,
    setSpecialNotes,
    specialNotes,
    tripRequest,
  } = useMatchingStore();
  const noMatches = Object.keys(selectedMatches).length === 0;
  const partnerNotRecommended = Object.values(selectedMatches).some((matchSelection) => matchSelection.match.excluded === true);

  useEffect(() => {
    if (tripRequest) {
      const sn = cooperativeMatch ? specialNotes : specialNotes.filter((n) => n !== MatchingNoteName.Special2TCsFor1Trip);
      const notes = [...new Set([...sn, ...getAutoGenSpecialNotes(tripRequest, cooperativeMatch)])];
      setSpecialNotes(notes);
    }
  }, [tripRequest]);

  const onChangeSpecialNotes = (_: React.SyntheticEvent, value: ComboBoxOption[]) => {
    const notes = value.map((ele) => ele.value as MatchingNoteName);
    setSpecialNotes(notes);
  };

  const selectedSpecialNotes = useMemo(() => specialNotes.map((note): ComboBoxOption => ({
    value: note,
    label: specialNotesOptions.find((option) => option.value === note)?.label!,
  })), [specialNotes]);

  return noMatches ? (
    <Navigate to="../match" replace />
  ) : (
    <MatchConfirmationView
      additionalComments={additionalComments}
      cooperativeMatch={cooperativeMatch}
      onChangeSpecialNotes={onChangeSpecialNotes}
      partnerNotRecommended={partnerNotRecommended}
      selectedMatches={selectedMatches}
      selectedSpecialNotes={selectedSpecialNotes}
      setAdditionalComments={setAdditionalComments}
      specialNotesOptions={specialNotesOptions}
      submissionError={error}
    />
  );
};

export default MatchConfirmationContainer;
